//Innyx Component
import {
  InputCustom,
  InputSelect,
  InputDate,
  GradeEdicao,
  MunicipioUf,
  MunicipioUfPerfilDados,
  RedeDeEnsinoPerfilDados,
  CustomFilterButton,
  TabelaAccordion,
  Tabela,
  TabelaInput,
  Paginacao,
  CustomTextArea,
} from "./components";

import BotaoCadastrar from "./components/Botoes/BotaoCadastrar.vue";

export default (app) => {
  const components = {
    InputCustom,
    InputSelect,
    InputDate,
    GradeEdicao,
    MunicipioUf,
    MunicipioUfPerfilDados,
    RedeDeEnsinoPerfilDados,
    CustomFilterButton,
    TabelaAccordion,
    Tabela,
    TabelaInput,
    Paginacao,
    BotaoCadastrar,
    CustomTextArea,
  };

  Object.entries(components).forEach(([name, component]) =>
    app.component(name, component)
  );
};
